<template>
  <div class="login-wrapper">
    <div class="login-card">
      <div class="login-logo">
        <img src="@/assets/img/logo.png" alt="Logo"/>
      </div>
      <h2 class="login-title">Bienvenido</h2>
      <p class="login-desc">Ingresa tu usuario y contraseña para acceder</p>
      <div class="login-form">
        <input @keydown.enter="login" v-model="email" type="email" placeholder="Usuario o correo" class="login-input"/>
        <div class="password-input-wrapper">
          <input
            @keydown.enter="login"
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            placeholder="Contraseña"
            class="login-input login-input-password"
          />
          <button
            type="button"
            class="password-toggle"
            :aria-label="showPassword ? 'Ocultar contraseña' : 'Ver contraseña'"
            @click="showPassword = !showPassword"
          >
            <i class="material-icons">{{ showPassword ? 'visibility_off' : 'visibility' }}</i>
          </button>
        </div>
        <button class="login-btn" @click="login">Entrar</button>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import Swal from "sweetalert2";
import {mapActions, mapMutations} from "vuex";
import {login, getUserPermissions} from "@/actions";

const body = document.getElementsByTagName("body")[0];
export default {
  name: "SigninCover",
  components: {
    MaterialInput,
    MaterialSwitch,
    MaterialButton
  },
  data() {
    return {
      Cargando: false,
      email: "",
      password: "",
      showPassword: false
    };
  },
  methods: {
    ...mapMutations(["SetPermisos"]),

    setUserDataInStore(userData) {
      this.$store.state.userid = userData.id;
      this.$store.state.username = userData.username || userData.email || '';
      this.$store.state.email = userData.email;
      this.$store.state.firstName = userData.firstName;
      this.$store.state.lastName = userData.lastName;
      this.$store.state.userSucursal = userData.sucursal;
      this.$store.state.rol = userData.groups?.[0]?.name || null;
    },

    setupAutoLogout(expirationTime) {
      // Clear any existing timeout
      if (window.logoutTimer) {
        clearTimeout(window.logoutTimer);
      }

      const timeUntilExpiration = expirationTime - Date.now();

      if (timeUntilExpiration > 0) {
        window.logoutTimer = setTimeout(() => {
          this.performSecurityLogout('Token expirado por seguridad');
        }, timeUntilExpiration);
      }
    },

    performSecurityLogout(reason) {
      // Clear all authentication data
      sessionStorage.removeItem("authData");
      sessionStorage.removeItem("token");
      $cookies.remove("token");

      // Clear store state
      this.$store.state.isAuth = false;
      this.$store.state.userid = null;
      this.$store.state.userSucursal = null;
      this.$store.state.username = null;
      this.$store.state.email = null;
      this.$store.state.firstName = null;
      this.$store.state.lastName = null;
      this.$store.state.rol = null;

      // Clear timeout
      if (window.logoutTimer) {
        clearTimeout(window.logoutTimer);
        window.logoutTimer = null;
      }

      // Notify user and redirect
      Swal.fire({
        icon: "warning",
        title: "Sesión Expirada",
        text: reason,
        allowOutsideClick: false
      }).then(() => {
        this.$router.push("/");
      });
    },


    async login() {
      this.Cargando = true;
      if (!this.email || !this.password) {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor, complete todos los campos."
        });
        this.Cargando = false;
        return;
      }
      try {
        const response = await login({username: this.email, password: this.password});
        const data = response.data.data.login;
        if (data.token) {
          // Store authentication data with expiration (8 hours)
          const expirationTime = Date.now() + (8 * 60 * 60 * 1000); // 8 hours in milliseconds
          const tokenData = {
            token: data.token,
            expiresAt: expirationTime,
            loginTime: Date.now()
          };

          // Guardar en localStorage para que persista entre actualizaciones
          localStorage.setItem("authData", JSON.stringify(tokenData));
          // También guardar en sessionStorage para compatibilidad
          sessionStorage.setItem("authData", JSON.stringify(tokenData));
          
          this.setUserDataInStore(data.user);
          this.$store.state.isAuth = true;
          this.$store.state.Cargando = false;

          // Cargar permisos del usuario
          try {
            const permissionsResponse = await getUserPermissions();
            if (permissionsResponse.data.data) {
              const { myPermissions, myRole } = permissionsResponse.data.data;
              this.$store.dispatch('setUserPermissions', myPermissions || []);
              this.$store.dispatch('setUserRole', myRole);
            }
          } catch (error) {
            console.error('Error cargando permisos:', error);
            // No bloquear el login si falla la carga de permisos
          }

          // Esperar a que se complete el SweetAlert antes de redirigir
          await Swal.fire({
            icon: "success",
            title: "Bienvenido",
            text: `Hola ${data.user.firstName} ${data.user.lastName}, has iniciado sesión correctamente.`,
            timer: 2000,
            showConfirmButton: false
          });

          // Redirigir después del mensaje
          this.$router.push("/dashboard");
        } else {
          await Swal.fire({
            icon: "error",
            title: "Error",
            text: data.error || "Credenciales incorrectas."
          });
          this.$store.state.isAuth = false;
        }
      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: "Error de conexión o credenciales inválidas."
        });
        this.$store.state.isAuth = false;
      } finally {
        this.Cargando = false;
      }
    }
  },
  created() {
    this.$store.state.isAuth = false;
  }
};
</script>
<style lang="scss" scoped>
@import '~@/assets/scss/variables';

.login-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, $color-primary 60%, $color-secondary 100%);
}

.login-card {
  background: $color-primary;
  border-radius: 20px;
  box-shadow: 0 8px 32px 0 rgba(2, 33, 38, 0.2);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-width: 2px;
  border-color: $color-background !important;
}

.login-logo img {
  width: 120px;
  margin-bottom: 1.5rem;
}

.login-title {
  color: $color-background;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.login-desc {
  color: $color-gray;
  font-size: 1rem;
  margin-bottom: 2rem;
  text-align: center;
}

.login-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.login-input {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid $color-gray;
  font-size: 1rem;
  background: $color-background;
  color: $color-primary;
  outline: none;
  transition: border-color 0.2s;
}

.login-input:focus {
  border-color: $color-secondary;
}

.password-input-wrapper {
  position: relative;
  width: 100%;
}

.login-input-password {
  padding-right: 2.75rem;
  width: 100%;
}

.password-toggle {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0.25rem;
  cursor: pointer;
  color: $color-gray;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: color 0.2s;
}

.password-toggle:hover {
  color: $color-primary;
}

.password-toggle .material-icons {
  font-size: 1.25rem;
}

.login-btn {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background: linear-gradient(90deg, $color-secondary 0%, $color-accent 100%);
  color: $color-primary;
  font-weight: bold;
  font-size: 1.1rem;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.login-btn:hover {
  background: linear-gradient(90deg, $color-accent 0%, $color-secondary 100%);
}
</style>
